import { ReactElement } from "react";
import "../../css/TeeStyles.css";
import aboutOne from "../../icons/assets/about-1.png";
import aboutTwo from "../../icons/assets/about-2.png";
import aboutThree from "../../icons/assets/about-3.png";
import aboutFour from "../../icons/assets/about-4.png";
import aboutFive from "../../icons/assets/about-5.png";
import aboutSix from "../../icons/assets/about-6.png";
import aboutEight from "../../icons/assets/about-8.png";

const SectionTwo = (): ReactElement => {
  const handleRedirect = () => {
    window.location.href = "https://t.me/+zk7FqSvnPnQ5Njdk";
  };
  return (
    <div className="pt-6 pt-6-mobile about-bg">
      <div className="d-flex flex-wrap justify-content-between wid100 px-md-5 px-4 pb-5">
        <div
          //   data-aos="fade-up-right"
          className="wid50 wid100Mobile order-1 order-md-0 mt-md-0 mt-5"
        >
          <img src={aboutOne} alt="" className="wid100 " />
        </div>
        <div
          //   data-aos="fade-up"
          className="wid50 wid100Mobile order-0 order-md-1"
        >
          <span className="fontSize30px d-block half-border boldSeven text-md-end text-center white">
            WHY MCM STUDIO?
          </span>
          <span className="fontSize20px white boldThree d-block text-md-end text-center mt-3 lh-base mb-md-0 mb-3">
            MCM studio is a multi-purpose studio space located in Lagos Nigeria.
            It is a creative hub dedicated to empowering individuals and
            businesses. <br />
            Ready to create stunning content with our top-notch audio-visual
            equipment, professional podcast, photography, and comfortable
            seminar space? We've got you covered!
          </span>
        </div>
      </div>
      <div
        data-aos="fade-up"
        className="wid80 d-flex flex-wrap mx-auto mt-md-0 mt-4 wid50Mobile"
      >
        <img
          src={aboutTwo}
          alt=""
          className="wid50 wid100Mobile order-md-0 order-1"
        />
        <div className="d-flex align-items-center wid50 wid100Mobile order-md-1 order-0">
          <div className="wid70 mx-auto">
            <span className="d-block wid100 text-center white boldSeven fontSize30px">
              OUR MISSION
            </span>
            <p className="d-block white boldThree mt-2 wid100 fontSize20px text-center">
              To deliver accessible, top-notch creative services that empower
              our clients to thrive.
            </p>
          </div>
        </div>
        <div className="d-flex align-items-center wid50 order-md-2 order-2 wid100Mobile mt-md-0 mt-5">
          <div className="wid70 mx-auto">
            <span className="d-block wid100 text-center white boldSeven fontSize30px">
              OUR VISION
            </span>
            <p className="d-block white boldThree mt-2 wid100 fontSize20px text-center">
              To deliver accessible, top-notch creative services that empower
              our clients to thrive.
            </p>
          </div>
        </div>
        <img
          src={aboutThree}
          alt=""
          className="wid50 order-md-3 order-3 wid100Mobile"
        />
      </div>
      <div className="d-flex justify-content-between flex-wrap wid100 px-md-5 px-4 pb-5 mt-6">
        <div data-aos="fade-up-right" className="wid50 wid100Mobile">
          <span className="fontSize30px d-block half-border-left boldSeven text-md-start text-center white">
            What Drives Us?
          </span>
          <span className="fontSize20px white boldThree d-block text-md-start text-center mt-3">
            At the core of our studio is a passion for creativity, innovation,
            and excellence. We are driven by the desire to push boundaries,
            delivering exceptional results that inspire and captivate. Our
            commitment to quality fuels every project we undertake, ensuring
            that we meet and exceed our clients' expectations.
          </span>
        </div>
        <div data-aos="fade-up" className="wid50 wid100Mobile mt-md-0 mt-4">
          <img src={aboutFour} alt="" className="wid100" />
        </div>
      </div>
      {/* <div className="d-flex wid100 justify-content-between px-5">
        <img src={aboutFive} alt="" className="wid57" />
        <img src={aboutSix} alt="" className="wid40" />
      </div> */}
      <div
        data-aos="fade-up"
        className="wid80 wid50Mobile mx-auto pb-5  mt-md-0 mt-4"
      >
        <div className="marginTopSmallNavLong section blackKsb wid100 mx-auto my-image-about-1 px-md-4 px-2">
          <div>
            <span className="d-block mx-auto text-center boldSeven fontSize30px pt-6 white">
              CREATE WITH US
            </span>
            <span className="d-block mx-auto text-center fontSize36px boldSeven pt-3 pb-5 white">
              We bring your ideas to life with precision and style.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionTwo;
